var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 17.2c-.8-.8-2-.8-2.8 0s-.8 2 0 2.8l9.6 9.6c.6.6 1.4.8 2.2.4.2 0 .4 0 .6-.2l9.6-9.6c.8-.8.8-2 0-2.8s-2-.8-2.8 0L18 23.6v-20c0-1.2-.8-2-2-2s-2 .8-2 2v20z"
  })));
};
export default SvgArrowDown;